// get cookie value
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

jQuery(document).ready(function($) {
    var submitForm = false;
    $('[data-toggle="tooltip"]').tooltip();
    var clientSecret = $('#client-secret').val();
    function saveCardDetails() {
        stripe.createPaymentMethod({
            type: 'card',
            card: paymentElement,
        }).then(function(result) {
            var paymentMethod = result.paymentMethod;
            stripe
                .confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: paymentElement
                    },
                })
                .then(function(result) {
                    if (!result.error) {
                        stripe.confirmPaymentIntent(clientSecret,
                            {payment_method: paymentMethod.id})
                            .then(function(result) {
                                console.log(result);
                                // Handle result.error or result.paymentIntent
                                // console.log(piresult);return false;
                                $('#submit').removeAttr('disabled');
                                if (paymentMethod && paymentMethod.id)
                                {
                                    submitForm = true;
                                    $('#card-token').val(paymentMethod.id);
                                    $('#submit').click();
                                    $('#submit').attr('disabled','disabled');
                                }
                            });
                    }
                    $('#billing').find('[type=submit]').removeAttr('disabled');
                });
        }).catch(err => {
            console.log(err);
            $('#billing').find('[type=submit]').removeAttr('disabled');
        });
        return '';
    }
    $(document).on('submit','#billing',function(e) {
        $('#billing').find('[type=submit]').attr('disabled','disabled');
        var paymentMethod = $('[name="paymentMethod"]:checked').val();
        if (paymentMethod.substring(5) === 'new' && !submitForm)
        {
            var token = saveCardDetails();
            e.preventDefault();
        }
    });

    var pkey,stripe, elements, paymentElement;
    const appearance = {
        theme: 'stripe',
        variables: {
            colorPrimary: '#e60d60',
            colorBackground: '#ffffff',
            colorText: '#30313d',
            colorDanger: '#df1b41',
            fontFamily: 'Ideal Sans, system-ui, sans-serif',
            spacingUnit: '2px',
            borderRadius: '4px',
            fontLineHeight: '30px'
            // See all possible variables below
        },

        rules: {
            '.Tab': {
                border: '1px solid #E0E6EB',
                boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)',
            }
        }
    };
    var style = {
        base: {
            color: "#32325d",
            backgroundColor: "#ffffff",
            fontFamily: 'Arial, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
                color: "#32325d"
            }
        },
        invalid: {
            fontFamily: 'Arial, sans-serif',
            color: "#fa755a",
            iconColor: "#fa755a"
        }
    };
    generateStripeInput();
    function generateStripeInput() {
        if ($('#pkey').length) {
            clientSecret = $('#client-secret').val();
            pkey = $('#pkey').val();
            stripe = Stripe(pkey, { locale: 'en-GB' });
            elements = stripe.elements({
                clientSecret: clientSecret
            });
            paymentElement = elements.create('card', { style: style});
            paymentElement.mount('#payment-element');
            submitForm = false;
        }
    }

    if(window.location.hash) {
        var hash = window.location.hash;
        if ($(hash).length)
        {
            if ($(hash).hasClass('modal'))
            {
                $(hash).modal('show');
            }
        }
    }

    var loadingHtml = '<div class="loading-overlay">' +
        '<div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>' +
        '</div>';
    $(document).on('change','.quantity-input',function(e) {
        var data = $(this).closest('form').serialize();
        if ($(this).val() == 0)
        {
            $(this).closest('.prop-border').addClass('removed');
        }
        else
            $(this).closest('.prop-border').removeClass('removed');
        $('#totals').addClass('tt-loading-animation');
        $.ajax(window.location.href,{
            data: data,
            method: 'post',
            success: function(data) {
                $('#totals').removeClass('tt-loading-animation');
                $('#totals').html($(data).find('#totals').html());
            }
        });
    }).on('click','[data-action="remove-item"]',function(e) {
        e.preventDefault();
        $(this).closest('.prop-border').addClass('removed').find('.quantity-input').val(0).trigger('change');
    });
    var startDate,endDate;
    if ($('#allowedDates').length)
    {
        startDate = new Date();
        endDate = new Date();
        startDate.setDate(startDate.getDate());
        endDate.setDate(endDate.getDate() + 180);
        initPicker();
    }

    var creditTimeout;
    $(document).on('change click','[name=useCredit]',function() {
        clearTimeout(creditTimeout);
        var $that = $(this);
        creditTimeout = setTimeout(function() {
            var $form = $that.closest('form');
            var url = $form.attr('action');
            if (typeof url == typeof undefined)
                url = window.location.href;
            $form.prepend('<div class="loading-overlay">'+$('#ajaxLoader').html()+'</div>');
            $.ajax(url,{
                method: 'get',
                data: $form.serialize(),
                success: function(data) {
                    $form.html($('<div>'+data+'</div>').find('#billing').html());
                    generateStripeInput();
                }
            });
        },300);
    });
    function initPicker() {
        var allowedDatesJson = $('#allowedDates').html();
        const allowedDatesParsed = JSON.parse(allowedDatesJson);
        var allowedDates = [];
        console.log(allowedDates);
        $.each(allowedDatesParsed, function (index, value) {
            allowedDates.push(value);
        });
        var themePath = $('#calendarThemePath').val();
        const picker = new easepick.create({
            element: "#datepicker",
            css: [
                'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css',
                themePath
            ],
            grid: 1,
            calendars: 1,
            setup(picker) {
                picker.on('select', (e) => {
                    const { view, date, target } = e.detail;
                    // do something
                    $('#datepicker').trigger('date-select');
                });
            },
            plugins: ['LockPlugin'],
            LockPlugin: {
                filter(date, picked) {
                    return !allowedDates.includes(date.format('YYYY-MM-DD'));
                },
                minDate: startDate,
                maxDate: endDate,
                inseparable: true
            },
            inline: true
        });
        $('#datepicker').css('display','none');
    }

    $(document).on('mouseover','.prop-availability-icon',function() {
        $(this).closest('.prop-border').addClass('hover');
    });

    $(document).on('mouseout','.text-overlay-hover',function() {
        $(this).closest('.prop-border').removeClass('hover');
    });

    $(document).on('change','#numDays',function(e) {
        var val = $(this).val();
        if (val > 3)
        {
            $('#specificDays').addClass('show');
            $('.specificDays').addClass('show');
            $('.genericDays').removeClass('show');
        }
        else
        {
            $('#specificDays').removeClass('show');
            $('.specificDays').removeClass('show');
            $('.genericDays').addClass('show');
        }
    }).on('change','input[name=invoiceAddress]',function(e) {
        if ($(this).val() == 'new' && $(this).is(':checked'))
        {
            $('#newAddress').addClass('show');
        }
        else
            $('#newAddress').removeClass('show');
    }).on('submit','[data-submit="ajax"]',function(e) {
        e.preventDefault();
        var url = $(this).attr('action');
        var method = $(this).attr('method');
        var refreshTarget = $(this).data('refresh');
        $(refreshTarget).prepend('<div class="loading-overlay">'+$('#ajaxLoader').html()+'</div>');
        $.ajax(url,{
            method: method,
            data: $(this).closest('form').serialize(),
            success: function(data) {
                $(refreshTarget).html($(data).find(refreshTarget).html());
                if ($('#msgContent').length) {
                    wp.editor.initialize('msgContent');
                }
            }
        });
    }).on('click','[data-ajax="modal"]',function(e) {
        e.preventDefault();
        var url = $(this).attr('href');

        $('#ajaxModalBody').html($('#ajaxLoader').html());
        $('#ajaxModal').modal('show');

        $.ajax(url,{
            cache: false,
            success: function(data) {
                $('#ajaxModalBody').html($(data).find('#modalBody').html());
                if ($('#closeButtonContain').length)
                    $('#closeButtonContain').html('<div class="text-left"><a href="#" data-dismiss="modal" class="btn btn-secondary">Close</a></div>');
                else
                    $('#ajaxModalBody').append('<div class="text-left"><a href="#" data-dismiss="modal" class="btn btn-secondary">Close</a></div>');
                if ($('#msgContent').length) {
                    wp.editor.initialize('msgContent');
                }
            }
        });

    });
    if ($('#msgContent').length) {
        wp.editor.initialize('msgContent');
    }

    $(document).on('change','input[name="paymentMethod"]',function(e) {
        if ($(this).val() == 'card-new' && $(this).is(':checked'))
        {
            $('#newCard').addClass('show');
        }
        else
            $('#newCard').removeClass('show');
    });

});

jQuery(document).on("click", "[data-prop-action]", function(event) {
    let propAction = this.dataset.propAction;
    let propId = this.dataset.propId;
    let propRefNo = this.dataset.propRefNo;
    let propName = this.dataset.propName;
    let propQty = this.dataset.propQty; // NOTE: probably not needed, remove later date
    let propMaxQty = this.dataset.propMaxQty; // NOTE: probably not needed, remove later date

    if (propAction === "addToCart" || propAction === "removeFromCart") {
        event.preventDefault();

        if (propAction === "addToCart") {
            this.innerHTML = `<span>Added</span>`;
        }

        $.ajax("/props/", {
            method: "POST",
            data: {
                update: propAction,
                pid: propId,
                quantity: propQty
            },
            success: function(data) {
                let quantity = $(data).find("#itemsQuantity").html();
                jQuery("#basketSuccess").hide();
                jQuery("#basketBody").show();
                jQuery("#itemsQuantity").html(quantity);
                jQuery(".itemsQuantity").each(function() {
                    console.log(quantity);
                    jQuery(this).html(quantity);
                });
                if (parseInt(quantity) > 0)
                {
                    $('.your-message .wpcf7-not-valid-tip').remove();
                }
                $("#basketList").html($(data).find("#basketList").html());
                $("#basketItems").data("basketItems", $(data).find("#basketItems").data("basketItems"));
                // console.log($("#basketItems").data("basketItems"));
                // console.log($(data).find("#basketItems").html());

                if (propAction === "addToCart") {

                    // Measure adding a product to a shopping cart by using an 'add' actionFieldObject
                    // and a list of productFieldObjects.
                    dataLayer.push({
                        'event': 'addToCart',
                        'ecommerce': {
                            'add': { // 'add' actionFieldObject measures.
                                'products': [{ //  adding a product to a shopping cart.
                                    'name': propName,
                                    'id': propRefNo,
                                    'quantity': 1
                                }]
                            }
                        }
                    });

                } else if (propAction === "removeFromCart") {

                    // Measure the removal of a product from a shopping cart.
                    dataLayer.push({
                        'event': 'removeFromCart',
                        'ecommerce': {
                            'remove': { // 'remove' actionFieldObject measures.
                                'products': [{ //  removing a product to a shopping cart.
                                    'name': propName,
                                    'id': propRefNo,
                                    'quantity': 1
                                }]
                            }
                        }
                    });

                }
            }
        });

    } else if (propAction === "productClick") {
        event.preventDefault();

        $.ajax($(this).attr("href"), {
            beforeSend: function() {
                document.getElementById("modalLgContent").innerHTML = "";
            },
            success: function(data) {
                $("#modalLgContent").html($('<div>'+data+'</div>').find("#propSingleContent").html());
                document.getElementById("propSingleContentBackBtn").style.opacity = "0";
                jQuery("#cartModalCloseOpen").show();

                $("#modalLgFrame").modal("show");

                dataLayer.push({
                    'event': 'productClick',
                    'ecommerce': {
                        'click': {
                            'products': [{ //  removing a product to a shopping cart.
                                'name': propName,
                                'id': propRefNo
                            }]
                        }
                    }
                });
            }
        });

    } else if (propAction === "checkout") {
        dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': 1,
                    },
                    'products': JSON.parse(document.getElementById('basketItems').dataset.basketItems)
                }
            }
        });

    } else if (propAction === "clearBasket") {
        event.preventDefault();

        $.ajax("/props/", {
            method: "POST",
            data: {
                update: "clearList"
            },
            success: function(data) {
                let quantity = $(data).find("#itemsQuantity").html();
                jQuery("#basketSuccess").hide();
                jQuery("#basketBody").show();
                jQuery("#itemsQuantity").html(quantity);
                jQuery(".itemsQuantity").each(function() {
                    console.log(quantity);
                    jQuery(this).html(quantity);
                });
                $("#basketList").html($(data).find("#basketList").html());
                $("#basketItems").data("basketItems", $(data).find("#basketItems").data("basketItems"));

            }
        });
    }
});

jQuery(document).on("click", "#cartModalCloseOpen", function(e) {
    e.preventDefault();

    jQuery('#modalLgFrame').modal('hide');

    jQuery('#modalLgFrame').on('hidden.bs.modal', function(e) {
        jQuery('#modalBasket').modal('show');
        $(e.currentTarget).unbind();
    });
});

$(document).ready(function() {
    "use strict";

    var wpcf7Elm = document.querySelector(".wpcf7");

    if (wpcf7Elm) {
        wpcf7Elm.addEventListener("wpcf7mailsent", function(event) {


            if ("20708" == event.detail.contactFormId) {

                jQuery('#itemsQuantity').text('0');
                jQuery.ajax('/props/',{
                    cache: false,
                    success: function(data) {
                        jQuery('#itemsQuantity').text(jQuery('<div>'+data+'</div>').find('#itemsQuantity').text());
                    }
                });

                let transactionID = getCookie("PHPSESSID");
                jQuery("#basketSuccess").show();
                jQuery("#basketBody").hide();

                // Send transaction data with a pageview if available
                // when the page loads. Otherwise, use an event when the transaction
                // data becomes available.
                dataLayer.push({
                    'ecommerce': {
                        'purchase': {
                            'actionField': {
                                'id': transactionID // Transaction ID. Required for purchases and refunds.
                            },
                            'products': JSON.parse(document.getElementById('basketItems').dataset.basketItems)
                        }
                    }
                });

            }

        }, false);
    }


    $(".saveListForm").submit(function(event) {
        event.preventDefault();

        var formVars = $(this);
        var submitBtn = formVars.find(".saveListFormBtn");
        var showErrors = formVars.find(".saveListErrors");

        $.ajax({
            type: formVars.attr("method"),
            url: formVars.attr("action"),
            data: formVars.serialize(),
            dataType: "json",
            cache: false,
            beforeSend: function beforeSend() {
                submitBtn.prop("disabled", true);
                showErrors.hide().empty();
            },
            success: function success(data) {
                submitBtn.prop("disabled", false);

                $("#itemsQuantity").load(document.URL + " #itemsQuantity");
                $("#products").load(document.URL + " #products");
                $("#loadListFormSessionId").load(document.URL + " #loadListFormSessionId");
                $("#deleteListFormSessionId").load(document.URL + " #deleteListFormSessionId");

                if (data.success) {
                    showErrors.show();

                    showErrors.append("<span class=\"success\">" + data.message + "</span>");

                    setTimeout(function() {
                        showErrors.fadeOut("slow");
                    }, 3000);

                } else if (data.errors) {
                    showErrors.show();

                    $.each(data.errors, function(key, value) {
                        showErrors.append("<span class=\"error\">" + value + "</span>");
                    });

                    setTimeout(function() {
                        showErrors.fadeOut("slow");
                    }, 9000);

                }

            }
        });

    });

    // Load Payments Modal on page load
    if (window.location.pathname === "/payment/") {
        $('#modalPayments').modal('show');
    }

});